import Head from 'next/head'
import { PlaywireContext } from 'shared-components/contexts/PlaywireContext'

interface AdBlockerScript {
  blockScript: string
}

/**
 * Blockthrough ad-block recovery tag. Rendered whenever ads are on (`enabled`, i.e. not
 * `adsDisabled`) — NOT once Playwire's `ramp.js` has initialised. From Nov 2021 to Oct 2026 it
 * waited for `inst` (first a timer, then the ramp-ready signal: a load-order choice so the tag
 * did not compete with page load). An ad blocker blocks `ramp.js` itself, so that wait never
 * ended for the one audience a recovery tag exists for, and Blockthrough only ever loaded for
 * readers without a blocker. `defer` keeps it out of the parse path; AdShield's loader
 * (`AdShieldScript`, first in `<head>`) runs alongside it.
 */
const AdBlockerScript: React.VFC<AdBlockerScript> = ({ blockScript }) => {
  const { enabled } = PlaywireContext.useContainer()

  if (!enabled) {
    return null
  }

  return (
    <Head>
      <script
        defer
        key="blocker-script"
        id="blocker-script"
        src={blockScript}
        type="text/javascript"
      />
    </Head>
  )
}

export default AdBlockerScript
